<template>
    <form action="">
        <fieldset>
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="">Código</label>
                        <input disabled :value="$props.solicitacao.id | formatarCodigo" class="form-control" type="text" />
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="">Data da solicitação</label>
                        <input disabled :value="$props.solicitacao.created_at | dataHoraFormatada" class="form-control" type="text" />
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="">Tipo de atendimento</label>
                        <input disabled :value="$props.solicitacao.tipo_atendimento | tipoAtendimento" class="form-control" type="text" />
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="">Situação</label>
                        <input disabled :value="$props.solicitacao.situacao | situacaoSolicitacao" class="form-control" type="text" />
                    </div>
                </div>
            </div>
			<div class="table-responsive">
			<label for="">Procedimentos da solicitação</label>
				<table class="table table-stripped table-condensed table-bordered">
					<thead>
						<tr>
							<th>Código</th>
							<th>Nome</th>
							<th>Tipo de consulta</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in $props.solicitacao.itens" :key="index">
							<td>{{item.contrato_procedimento.procedimento.codigo}}</td>
							<td>{{item.contrato_procedimento.procedimento.nome}}</td>
							<td>{{item.tipo_consulta | tipoConsulta}}</td>
						</tr>
					</tbody>
				</table>
			</div>
        </fieldset>
        <fieldset>
            <legend>Paciente <a data-toggle="tooltip" data-placement="top" title="Paciente possui agendamentos ainda não realizados." v-if="showInfo" href="" @click.prevent="$emit('showModalNaoRealizados')"><span class="fa fa-info-circle"></span></a></legend>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">Cartão do SUS</label>
                        <input disabled :value="$props.solicitacao.paciente.cartao_sus" class="form-control" type="text" />
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="form-group">
                        <label for="">Nome</label>
                        <input disabled :value="$props.solicitacao.paciente.nome" class="form-control" type="text" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">Data de nascimento</label>
                        <input disabled :value="$props.solicitacao.paciente.data_nascimento | dataFormatada" class="form-control" type="text" />
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label for="">Sexo</label>
                        <input disabled :value="$props.solicitacao.paciente.sexo | sexo" class="form-control" type="text" />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">Nome da mãe</label>
                        <input disabled :value="$props.solicitacao.paciente.nome_mae" class="form-control" type="text" />
                    </div>
                </div>
            </div>
        </fieldset>
        <fieldset>
            <legend>Marcação</legend>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="">Unidade solicitante</label>
                        <input disabled :value="$props.solicitacao.itens[0].contrato_procedimento.contrato.unidade.nome" class="form-control" type="text" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">Profissional solicitante</label>
                        <input disabled :value="$props.solicitacao.profissional.nome" class="form-control" type="text" />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">Usuário marcador</label>
                        <input disabled :value="$props.solicitacao.usuario.name" class="form-control" type="text" />
                    </div>
                </div>
            </div>
        </fieldset>
    </form>
</template>

<script>
export default {
    props: ["solicitacao", "showInfo"],
    data: () => ({}),
    mounted() {},
    methods: {},
    watch: {},
    components: {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// solicitacaoDetalhes.vue?a606b89e